import { IFertiliserStock, IManureStock, ISeedStock, ITypedStock } from "@omnia/types";
import { FertiliserStockVm } from "./fertiliserStockVm"
import { ManureStockVm } from "./manureStockVm"
import { SeedStockVm } from "./seedStockVm"
import { StockVm } from "./stockVm"
import { StockType } from "../omnia";


export function createStockVm(stock: ITypedStock): StockVm {

    switch (stock.StockType) {

        case StockType.Seed:
            return new SeedStockVm(<ISeedStock>stock);

        case StockType.Fertiliser:
            return new FertiliserStockVm(<IFertiliserStock>stock);

        case StockType.Manure:
            return new ManureStockVm(<IManureStock>stock);

        default:
            throw new Error("Unsupported stock type: " + stock.StockType);
    }

}
